import api from "./axios";

export const MyProfile = async ({ queryKey }) => {
  const [_key, { reference_id }] = queryKey;
  const response = await api.get("/users/profile/details/", {
    params: { reference_id },
  });
  return response.data.data;
};

export const ProfileMatch = async ({ queryKey }) => {
  const [_key, { user_id }] = queryKey;
  const response = await api.get("/users/profile/match-percentage/", {
    params: { user_id },
  });
  return response.data.data;
};

export const SimiliarMatches = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/similar-matches/", {
    params,
  });
  return response.data.data;
};

export const updateUserPhoto = async (payload) => {
  const response = await api.post(
    "/users/onboarding/update-user-photo/",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const EditProfile = async (payload) => {
  const response = await api.patch("/users/profile-update/", payload);
  return response?.data?.data;
};
